export { default as FormHome } from './FormHome';
export { default as FormBox } from './FormBox';
export { default as FormHistory } from './FormHistory';



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/forms/index.js